import timedFetch from 'middleware/timedFetch';
import type { ReviewSummarizationResponse } from 'types/reviewSummarization';

export const getReviewSummarization = ({
  cloudfrontUrl,
  productId,
  controller,
  fetcher = timedFetch('getSponsoredAdsBannerAds')
}: {
  cloudfrontUrl: string;
  productId: string;
  controller: AbortController;
  fetcher?: Function;
}): Promise<Response<ReviewSummarizationResponse>> => {
  const opts = {
    method: 'get',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': '*/*'
    },
    signal: controller.signal
  };
  return fetcher(getReviewSummarizationUrl({ cloudfrontUrl, productId }), opts);
};

export const getReviewSummarizationUrl = ({ cloudfrontUrl, productId }: { cloudfrontUrl: string; productId: string }) =>
  `${cloudfrontUrl}/v1/review_summary/${productId}.json`;
